export const EXCEL_FILE_TYPES = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

export const VERIFICATION_ALLOWED_FILE_TYPES = ["text/csv", "application/pdf", ...EXCEL_FILE_TYPES];

// The API body limit is 250mb and base64 adds a third, so 150MB fits
export const DOC_SCAN_MAX_FILE_SIZE_MB = 150;
export const DOC_SCAN_MAX_FILE_SIZE_BYTES = DOC_SCAN_MAX_FILE_SIZE_MB * 1024 * 1024;
